export const config = {
  defaultTenantId: import.meta.env.VITE_DEFAULT_TENANT_ID || '',
  appInsights: {
    connectionString: import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING as string | undefined,
  },
  clerk: {
    publishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
    // JWT template name from Clerk Dashboard → Configure → JWT Templates
    // Set VITE_CLERK_JWT_TEMPLATE in .env to use a named template.
    // The template must include: { "public_metadata_roles": "{{user.public_metadata.roles | json}}" }
    jwtTemplate: import.meta.env.VITE_CLERK_JWT_TEMPLATE || undefined,
  },
  timeZone: {
    default: 'America/New_York',
  },
  posthog: {
    key: import.meta.env.VITE_POSTHOG_KEY as string | undefined,
    host: import.meta.env.VITE_POSTHOG_HOST as string | undefined,
  },
  googleAds: {
    // Google Ads tag id (AW-XXXXXXXXXX). When set, vite.config.ts injects gtag.js
    // into <head> and services/googleAds.ts reports conversions. Leave unset
    // outside production so test sign-ups never count as conversions.
    id: (import.meta.env.VITE_GOOGLE_ADS_ID as string | undefined) || undefined,
  },
  api: {
    // Default base URL for backward compatibility
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    // Service-specific base URLs (defaults to main API if not specified)
    users: import.meta.env.VITE_API_USERS_BASE_URL || import.meta.env.VITE_API_BASE_URL,
    tenants: import.meta.env.VITE_API_TENANTS_BASE_URL || import.meta.env.VITE_API_BASE_URL,
    courses: import.meta.env.VITE_API_COURSES_BASE_URL || import.meta.env.VITE_API_BASE_URL,
    cpeRequirements: import.meta.env.VITE_API_CPE_REQUIREMENTS_BASE_URL || import.meta.env.VITE_API_BASE_URL,
  },
};
